export default {
  text: 'Get a {discountOriginal} {discount} on your Kegel plan',
  discountOriginal: '{discountOriginal}%',
  discount: '{discount}% discount',
}
